import { IVcfFuelStatusResponse, VcfFuelStatusClient } from './VcfFuelStatusClient';
import { VcfMeasurementsError } from '../errors/VcfMeasurementsError';
import { DevicePlatform } from '../../enums';

export interface ICruisingRange {
    readonly lastUpdate: string;
    readonly value: number;
}

export class VcfFuelStatusService {
    constructor(private readonly vcfFuelStatusClient: VcfFuelStatusClient) {
    }

    public async getCruisingRange(vin: string, devicePlatform: DevicePlatform): Promise<ICruisingRange> {
        const isWcar = devicePlatform === DevicePlatform.WCAR;
        let fuelStatusResponse: IVcfFuelStatusResponse | undefined;
        fuelStatusResponse = await this.vcfFuelStatusClient.getFuelStatus(vin, isWcar);
        try {
            const data = fuelStatusResponse?.data![0]!;
            const lastUpdate = data.carCapturedTimestamp;
            const value = parseInt(data.properties.find(p => p.name === 'remainingRange_km')!.value);
            return {lastUpdate, value};
        } catch (e: any) {
            throw new VcfMeasurementsError('Could not parse VCF fuel status response');
        }
    }
}